import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const sagiTrades: SeasonTrades[] = [
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.michael,
        sentAway: "Al Jefferson and Demarcus Cousins", 
        gotInReturn: "Chris Bosh, Marc Gasol and Mike Conley",
        amongWorstTrades: true
      },
      {
        otherTeam: manager.jDog,
        sentAway: "John Wall and Marc Gasol",
        gotInReturn: "Kobe Bryant and David Lee",
      },
      {
        otherTeam: manager.oded,
        sentAway: "Chris Bosh and Kyle Korver",
        gotInReturn: "Joakim Noah, David West and Dorell Wright",
      },
    ],
  },
];
